import { render, staticRenderFns } from "./SearchFreeSpecimenModal.vue?vue&type=template&id=4a214d1e&scoped=true"
import script from "./SearchFreeSpecimenModal.vue?vue&type=script&lang=js"
export * from "./SearchFreeSpecimenModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a214d1e",
  null
  
)

export default component.exports